import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import globalStyle from "../../globalStyle";
import GlobalButton from "../CustomButton";
import Label from "../Label";
import TextInput from "../TextInputs";
import { useTranslation } from "react-i18next";
import EditIcon from "@mui/icons-material/Edit";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import DialogHeader from "../Dialog/Header";
import DialogBody from "../Dialog/Body";
import DialogActionButtons from "../Dialog/Footer";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

const UpdateSubscriptionDialog = forwardRef(({ onConfirm }, ref) => {
  const { t } = useTranslation(["common"]);
  const [open, setOpen] = useState(false);
  const [dialogData, setDialogData] = useState({});
  const [price, setPrice] = useState("");
  const [yearlyPrice, setYearlyPrice] = useState("");
  const [error, setError] = useState(false);
  const [yearlyError, setYearlyError] = useState(false);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      setDialogData(params);
      setPrice(params.params.price);
      setYearlyPrice(params.params.yearlyPrice ? params.params.yearlyPrice : 0);
      setOpen(true);
    },
    closeDialog() {
      handleClose();
    },
  }));

  const handleClose = () => {
    setOpen(false);
    setDialogData({});
    setPrice("");
    setError(false);
    setYearlyError(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="client-block-dialog-title"
      open={open}
    >
      <DialogHeader
        title={t("updatePrice")}
        secondaryHeading={t("updatePriceInfo")}
        icon={<PriceChangeIcon />}
        onClose={handleClose}
      />
      <DialogBody>
        <Label labelText={t("MonthlyPrice")} required />
        <TextInput
          styleProps={{
            ...globalStyle.textField,
          }}
          type={"number"}
          placeholder={t("enterMonthlyPrice")}
          inputError={error}
          helperText={error && t("validation.monthlyPriceRequired")}
          value={price}
          onChange={(e) => {
            setError(false);
            setPrice(e.target.value);
          }}
        />
        <Label
          labelText={t("yearlyPrice")}
          required
          labelProps={{ marginTop: "20px" }}
        />
        <TextInput
          styleProps={{
            ...globalStyle.textField,
          }}
          type={"number"}
          placeholder={t("enterYearlyPrice")}
          inputError={yearlyError}
          helperText={yearlyError && t("validation.yearlyPriceRequired")}
          value={yearlyPrice}
          onChange={(e) => {
            setYearlyError(false);
            setYearlyPrice(e.target.value);
          }}
        />
      </DialogBody>

      <DialogActionButtons
        onConfirm={() => {
          if (!price) {
            setError(true);
          } else if (!yearlyPrice) {
            setYearlyError(true);
          } else {
            onConfirm({ ...dialogData, newPrice: price, yearlyPrice });
          }
        }}
        onCancel={handleClose}
        confirmText={t("update")}
        cancelText={t("cancel")}
      />

    </BootstrapDialog>
  );
});

export default UpdateSubscriptionDialog;
